/**
 * Switch Component - Component Definition
 * =======================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { SwitchController } from './controller';
import { SWITCH_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, DEFAULTS, SwitchSize } from './constants';

export interface ISwitchComponentBindings {
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  size?: SwitchSize;
  inputId?: string;
  onChange?: (args: { checked: boolean }) => void;
}

export const switchComponentDefinition: IComponentOptions = {
  template: SWITCH_TEMPLATE,
  controller: SwitchController,
  require: { ngModelCtrl: '?ngModel' },
  // Slot nombrado: <ec-label> dentro del componente.
  transclude: { labelSlot: '?ecLabel' },
  bindings: {
    label: '@',
    ariaLabel: '@',
    disabled: '<',
    size: '@',
    inputId: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.switch';

const switchModule: IModule = angular
  .module(MODULE_NAME, [])
  .component('ecSwitch', switchComponentDefinition);

export { SwitchController, SWITCH_TEMPLATE, SIZES, BASE_CLASSES, DEFAULTS };
export type { SwitchSize } from './constants';
export default switchModule;
